// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import organisationClientEntity from './entities/organisation-client.json';
import organisationClientMenu from '../pages/organisation-client/menu.json';
import organisationClientFullForm from '../pages/organisation-client/forms/full.json';
import organisationClientContextForm from '../pages/organisation-client/forms/context.json';
import organisationClientMiniForm from '../pages/organisation-client/forms/mini.json';
import organisationClientLookupForm from '../pages/organisation-client/forms/lookup.json';
import organisationClientTableView from '../pages/organisation-client/views/table.json';
import organisationClientCardsView from '../pages/organisation-client/views/cards.json';
import organisationClientDashboardView from '../pages/organisation-client/views/dashboard.json';

/** Тип запису «Клієнт» зі сторінками пакета: меню, форми та подання з pages/organisation-client/. */
export const organisationClientDefinition: IRecordTypeDefinition = {
  ...organisationClientEntity,
  views: assembleViewSet({
      table: organisationClientTableView,
      cards: organisationClientCardsView,
      dashboard: organisationClientDashboardView,
  }),
  form: organisationClientFullForm,
  forms: { full: organisationClientFullForm, context: organisationClientContextForm, mini: organisationClientMiniForm, lookup: organisationClientLookupForm },
  menu: organisationClientMenu,
} as IRecordTypeDefinition;
